/** Client helper for the /api/sms/send proxy route (Telebroad; API key stays server-side). */
import { postApiJson } from './apiClient'

export interface SendSmsParams {
  to: string
  body: string
  /** Optional business from-number; server default is used when omitted. */
  from?: string
}

/** Digits only; 10-digit numbers get the US/Canada country code (matches server normalization). */
export function normalizePhoneDigits(raw: string): string {
  const digits = (raw || '').replace(/\D/g, '')
  return digits.length === 10 ? '1' + digits : digits
}

/** Pretty-print a normalized US number for display: 17184272111 -> (718) 427-2111 */
export function formatPhoneForDisplay(raw: string): string {
  const digits = normalizePhoneDigits(raw)
  if (digits.length === 11 && digits.startsWith('1')) {
    return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`
  }
  return raw
}

export async function sendSms(params: SendSmsParams): Promise<void> {
  await postApiJson('/api/sms/send', params, { auth: true })
}
